'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _linkWrapper = require('../../link-wrapper');

var _linkWrapper2 = _interopRequireDefault(_linkWrapper);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

var _media = require('../../utils/media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var render = function render(_ref) {
	var props = _ref.props;
	var alt = props.alt,
	    path = props.path,
	    url = props.url,
	    styleClasses = props.styleClasses,
	    target = props.target;

	var styles = {
		'border-radius': props.borderRadius
	};

	return (0, _createCmsComponent2.default)(url ? (0, _magicVirtualElement2.default)(
		_linkWrapper2.default,
		{ href: url, 'class': ['CMS-MediaLink', props.class, styleClasses.Link], 'data-style-attr': 'Link', target: target ? '_blank' : '' },
		(0, _magicVirtualElement2.default)(_media.Image, { source: path, alt: alt, style: !styleClasses.Media && styles, 'class': styleClasses.Media, 'data-style-attr': 'Media' })
	) : (0, _magicVirtualElement2.default)(_media.Image, { source: path, 'class': styleClasses.Media, 'data-style-attr': 'Media', alt: alt, style: !styleClasses.Media && styles }), props);
};

exports.default = { render: render };